module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/heartbeat.svg?d5f003b42275b9e98e3595a36b664402";